

export const Login_cover = "https://assets.nflxext.com/ffe/siteui/vlv3/32c47234-8398-4a4f-a6b5-6803881d38bf/c29435a3-418d-47a5-99f4-4cd2093856ad/EG-en-20240122-popsignuptwoweeks-perspective_alpha_website_large.jpg";
export const Logo_url = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";
export const User_icon = "https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg"
export const loggedInUserIcon = 'https://cdn-icons-png.flaticon.com/512/9131/9131529.png';
export const options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjYjM2MTQxZDA5ZTEzMWMxYzhkOWFjNjVkOTU1MmYxYiIsInN1YiI6IjY1YmM3YTkxNWMwNzFiMDE3ZDcyOWQ0MyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.TlxSNpOMM1OhN0mj-ApX-L2yE37hXpGEoewH0KmW56A'
    }
  };

  export const img_CDN_url = "https://image.tmdb.org/t/p/w500";
  export const BG_URL =
  "https://assets.nflxext.com/ffe/siteui/vlv3/fc164b4b-f085-44ee-bb7f-ec7df8539eff/d23a1608-7d90-4da1-93d6-bae2fe60a69b/IN-en-20230814-popsignuptwoweeks-perspective_alpha_website_large.jpg";

  export const supportedLangs = [
    {id: "EN" , name: "English"},
    {id: "AR" , name: "Arabic"},
    {id: "spanish", name: "Spanish" },
  ];

  export const openAi_key = process.env.REACT_APP_openAi_key;